export default {
    area_of_refuge: {
        name: "Area Of Refuge",
        url: "nfpa_general_use/area_of_refuge",
    },
    combustible_metals: {
        name: "Combustible Metals",
        url: "nfpa_general_use/combustible_metals",
    },
    do_not_use_elevator_in_case_of_fire: {
        name: "Do Not Use Elevator In Case Of Fire",
        url: "nfpa_general_use/do_not_use_elevator_in_case_of_fire",
    },
    electrical_equipment: {
        name: "Electrical Equipment",
        url: "nfpa_general_use/electrical_equipment",
    },
    emergency_exit: {
        name: "Emergency Exit",
        url: "nfpa_general_use/emergency_exit",
    },
    fire_alarm_box: {
        name: "Fire Alarm Box",
        url: "nfpa_general_use/fire_alarm_box",
    },
    fire_extinguisher: {
        name: "Fire Extinguisher",
        url: "nfpa_general_use/fire_extinguisher",
    },
    fire_hose_or_standpipe: {
        name: "Fire Hose Or Standpipe",
        url: "nfpa_general_use/fire_hose_or_standpipe",
    },
    flammable_liquids: {
        name: "Flammable Liquids",
        url: "nfpa_general_use/flammable_liquids",
    },
    no_campfires: {
        name: "No Campfires",
        url: "nfpa_general_use/no_campfires",
    },
    no_cooking: {
        name: "No Cooking",
        url: "nfpa_general_use/no_cooking",
    },
    no_hanger: {
        name: "No Hanger",
        url: "nfpa_general_use/no_hanger",
    },
    "no_open_flame_-_flame": {
        name: "No Open Flame - Flame",
        url: "nfpa_general_use/no_open_flame_-_flame",
    },
    "no_open_flame_-_lighted_match": {
        name: "No Open Flame - Lighted Match",
        url: "nfpa_general_use/no_open_flame_-_lighted_match",
    },
    no_smoking: {
        name: "No Smoking",
        url: "nfpa_general_use/no_smoking",
    },
    not_an_exit: {
        name: "Not An Exit",
        url: "nfpa_general_use/not_an_exit",
    },
    ordinary_combustibles: {
        name: "Ordinary Combustibles",
        url: "nfpa_general_use/ordinary_combustibles",
    },
    use_stairs_in_case_of_fire_1: {
        name: "Use Stairs In Case of Fire 1",
        url: "nfpa_general_use/use_stairs_in_case_of_fire_1",
    },
    use_stairs_in_case_of_fire_2: {
        name: "Use Stairs In Case of Fire 2",
        url: "nfpa_general_use/use_stairs_in_case_of_fire_2",
    },
}
